<div id="email-verification-dialog-container" class="modal-dialog">
  <div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabel]="'email-verification_title' | translate">
    <div class="goreact-modal-header">
      <span></span>
      <button type="button" class="close-btn" (click)="close()" attr.aria-label="{{ 'common_close' | translate }}">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body" >
      @if (loading || error) {
        <div class="message">
          @if (error) {
            <div class="error">
              <p translate="common_unknown-error"></p>
              <button class="primary-btn" (click)="sendVerification()" translate="common_retry"></button>
            </div>
          }
          @if (loading) {
            <p translate="common_please-wait_loading"></p>
          }
        </div>
      }

      @if (!loading && !error) {
        <email-verification
          [email]="data.email"
          (onComplete)="close($event)">
        </email-verification>
      }
    </div>
  </div>
</div>
